import { Component, OnInit } from '@angular/core';
import { NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApplicationService } from '../../../services/application.service';
import { LookupService } from '../../../services/lookup.service';
import { club } from '../../../models/club';

@Component({
  selector: 'app-create-drill',
  standalone: true,
  imports: [FormsModule, NgFor],
  templateUrl: './create-drill.component.html',
  styleUrl: './create-drill.component.css'
})
export class CreateDrillComponent implements OnInit {
  constructor(private applicationService:ApplicationService, private lookupService:LookupService) {}

  clubs:club[] = [];
  drill = {
    label: '',
    description: '',
    club_id: null
  };

  ngOnInit(): void {
    this.getClubs();
  }

  saveDrillClicked() {
    // call your save drill API here
  }

  async getClubs() {
    this.clubs = await this.lookupService.searchClubs();
  }
}
